var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"son"},[_c('div',{staticClass:"inner"},[_c('inputdata',{attrs:{"rules":_vm.count[_vm.index].rules}})],1),_vm._v(" "),_c('div',{staticClass:"icondelete"},[(_vm.count.length>=1)?_c('span',{staticClass:"el-icon-remove-outline",on:{"click":function($event){return _vm.removechild(_vm.index)}}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e20b56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/children/childrenf.vue
// module id = null
// module chunks = 